import { render, staticRenderFns } from "./recommended_add.vue?vue&type=template&id=3b024ee2&"
import script from "./recommended_add.vue?vue&type=script&lang=js&"
export * from "./recommended_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports